// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__20qrR","header":"Messages_header__2fmtr"};